export const initAttributes = () => {
    function setVariable(name, value) {
        document.documentElement.style.setProperty(`--${name}`, value);
    }

    // расчитать ширину скроллбара
    function setScrollbarWidth() {
        let div = document.createElement(`div`);
        div.style.overflowY = `scroll`;
        div.style.width = `50px`;
        div.style.height = `50px`;
        document.body.append(div);
        const scrollWidth = (div.offsetWidth - div.clientWidth).toString();
        div.remove();
        setVariable(`scrollbar`, `${scrollWidth}px`);
    }

    // расчитать высоту вьюпорта
    function setVh() {
        let vh = window.innerHeight * 0.01;
        setVariable(`vh`, `${vh}px`);
    }

    // расчитать высоту хедера
    function setHeaderHeight() {
        const header = document.querySelector(`.header`);
        let value = header ? header.offsetHeight : 0;
        setVariable(`header-height`, `${value}px`);
    }

    // расчитать высоту нижней навигации на мобилке
    function setHeaderNavHeight() {
        const nav = document.querySelector(`.header-nav`);
        let value = nav ? nav.offsetHeight : 0;
        setVariable(`header-nav-height`, `${value}px`);
    }

    // расчитать высоту футера
    function setFooterHeight() {
        const footer = document.querySelector(`.footer`);
        let value = footer ? footer.offsetHeight : 0;
        setVariable(`footer-height`, `${value}px`);
    }

    setScrollbarWidth();
    setVh();
    setHeaderHeight();
    setHeaderNavHeight();
    setFooterHeight();
};
